import React from 'react'
import { usePromiseTracker } from 'react-promise-tracker';
// import Loader from 'react-spinners/PulseLoader'
import { PulseLoader } from "react-spinners";

import "./spinner.css"

function LoadingSpinnerComponent( { className = '' }) {
    const { promiseInProgress } = usePromiseTracker();
    return (
        promiseInProgress && (
            <div className={`spinner ${className}`}>
                <div>
                    <PulseLoader type="ThreeDots" color="#2BAD60" height="100" width="100" />
                </div>
            </div>
        )
    )
}

export default LoadingSpinnerComponent

// import React from 'react'
// import { usePromiseTracker } from 'react-promise-tracker';
// import { PulseLoader } from "react-spinners";

// import "./spinner.css"

// function LoadingSpinnerComponent() {
//     const { promiseInProgress } = usePromiseTracker();
//     return (
//         promiseInProgress && (
//             <div className="spinner">
//                 <div>
//                     <PulseLoader color="#2BAD60" size={15} />
//                 </div>
//             </div>
//         )
//     )
// }

// export default LoadingSpinnerComponent

